import { Link } from 'react-router-dom'
import Icon from '../components/docs/Icon'
import Cased from '@/components/ui/Cased'
export default function NotFoundPage() {
  return (
    <div className="mds-container doc-not-found">
      <span className="mds-eyebrow">404 / Page not found</span>
      <h1 className="mds-hero-title">
        <Cased>Let&apos;s get you back on track.</Cased>
      </h1>
      <p className="mds-lead">
        This page isn&apos;t part of the design system. Find what you need in
        the documentation.
      </p>
      <div className="mds-cluster doc-not-found__actions">
        <Link to="/" className="mds-button mds-button--primary mds-button--lg">
          Back to MDS <Icon name="arrow" size={17} />
        </Link>
        <Link
          to="/search"
          className="mds-button mds-button--secondary mds-button--lg"
        >
          Search the docs
        </Link>
      </div>
    </div>
  )
}
